<template lang="pug">
  .c-highlights__container
    .c-highlights(v-if='notEmpty' :class='classSelector')
      .c-hightlight__headline(v-if='headline' :class='headlineClass') {{ headline }}
      .c-highlights--loaded(v-if='hotelListFull && flightListFull && packageListFull')
        .c-highlight__item(v-if='hotelList && hotelList[0].config.count.total > 0')
          HotelTeaser(:hotelLists='hotelList' :dateFormat='dateFormat' :timeFormat='timeFormat' :searchTerm='searchTerm')
        .c-highlight__item(v-if='flightList && flightList[0].data.ranks[0].items')
          FlightTeaser(:flightLists='flightList' :searchTag='searchTag' :dateFormat='dateFormat' :timeFormat='timeFormat' :searchTerm='searchTerm' :departureAirportName='departureAirportCityName' :arrivalAirportName='arrivalAirportCityName' )
        .c-highlight__item(v-if='packageList && packageList[0].data.ranks[0].items')
          PackageTeaser(:packageLists='packageList' :dateFormat='dateFormat' :timeFormat='timeFormat' editable='true')
      .c-hightlights--loading(v-else)
        span.c-hightlights--loading__point
        span.c-hightlights--loading__point
        span.c-hightlights--loading__point
</template>

<script>
import packageSchema from './utils/schemas/package.js'
import PackageTeaser from '@/components/PackageTeaser.vue'
import hotelSchema from './utils/schemas/hotel.js'
import HotelTeaser from '@/components/HotelTeaser.vue'
import flightSchema from './utils/schemas/flight.js'
import FlightTeaser from '@/components/FlightTeaser.vue'
import dbPages from '@/api/dbpages'
import dbViews from '@/api/dbviews'
import uniqId from 'uniqid'
import fecha from 'fecha'
import axios from 'axios'
import packageSetup from '@/settings/packageSetup.js'
import hotelSetup from '@/settings/hotelSetup.js'
import flightSetup from '@/settings/flightSetup.js'

export default {
  name: 'Package',
  props: {
    searchTag: String,
    headline: String,
    headlineClass: String
  },
  components: {
    PackageTeaser,
    HotelTeaser,
    FlightTeaser
  },
  data() {
    return {
      packageList: [],
      hotelList: [],
      flightList: [],
      departureAirportCityName: '',
      arrivalAirportCityName: '',
      dateFormat: this.getDateFormat(),
      timeFormat: this.getTimeFormat(),
      packageListFull: false,
      hotelListFull: false,
      flightListFull: false,
      searchTerm: '',
      classSelector: '',
      notEmpty: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true
    }
  },
  created() {
    if (window.bananasHighlightsConfigData !== undefined) {
      if (window.bananasHighlightsConfigData.hasOwnProperty('classSelector')) {
        this.classSelector = window.bananasHighlightsConfigData.classSelector
      }
    }
    this.checkTrackingAllowed()
    if (this.trackingAllowed) {
      this.setUserId()
    }

    // Check for blog post pages if highlights are allowed
    let pagePostId = null
    if (window.dataLayer.length > 0) {
      if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
        pagePostId = parseInt(window.dataLayer[0].pagePostId)
      }
    }
    if (window.gtm_tracking !== undefined && window.gtm_tracking !== null) {
      if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
        pagePostId = parseInt(window.gtm_tracking.pagePostId)
      }
    }
    if (pagePostId !== null) {
      let vm = this
      let market = ''
      switch (this.$store.getters.getLocale) {
        case 'de-AT':
          market = 'urlaubspiraten.at'
          break
        case 'de-CH':
          market = 'ferienpiraten.ch'
          break
        case 'en-UK':
          market = 'holidaypirates.com'
          break
        case 'en-US':
          market = 'travelpirates.com'
          break
        case 'it-IT':
          market = 'piratinviaggio.it'
          break
        case 'nl-NL':
          market = 'vakantiepiraten.nl'
          break
        case 'pl-PL':
          market = 'wakacyjnipiraci.pl'
          break
        case 'fr-FR':
          market = 'voyagespirates.fr'
          break
        case 'es-ES':
          market = 'viajerospiratas.es'
          break
        default:
          market = 'urlaubspiraten.de'
      }
      axios
        .post('https://tremo-deals.holidaypirates.group/admiraldeal', {
          action: 'get',
          blog: market,
          id: pagePostId
        })
        .then(function(response) {
          if (response.data.enabled) {
            // Grab config data for package teaser
            // config variable should come from source code as variable bananaGlobalConfigData
            if (
              vm.searchTag !== '' &&
              vm.$store.getters.getLocaleShort === 'de'
            ) {
              const packageConfig = vm.setPackageProvider()
              let packageSearchObject = packageSetup
              packageSearchObject.language = vm.$store.getters.getLocaleShort
              let packageData = null
              let findLocationBasedPackageOffer = false
              // First Object are package config
              if (vm.searchTag !== '') {
                vm.searchTerm =
                  vm.searchTag[0].toUpperCase() + vm.searchTag.substring(1)
                // get automated destination from autosuggest with searching with url tag
                axios
                  .get(
                    packageConfig.autosuggestEndpoint +
                      '?data[term]=' +
                      vm.searchTag +
                      '&data[filters][types]=' +
                      packageConfig.data.filters.types +
                      '&config[target]=' +
                      packageConfig.config.target +
                      '&config[type]=' +
                      packageConfig.config.type +
                      '&config[source]=123&config[language]=' +
                      vm.$store.getters.getLocaleShort.toLowerCase()
                  )
                  .then(function(response) {
                    if (response.data.data.results.length > 0) {
                      let resultDestination =
                        response.data.data.results[0].values.payload
                      let payLoadArray = resultDestination.split('&')
                      payLoadArray.forEach(payload => {
                        let property = payload.split('=')
                        switch (property[0]) {
                          case 'region_groups[]':
                            delete packageSearchObject.destinationToSearch.city
                            delete packageSearchObject.destinationToSearch
                              .region
                            packageSearchObject.destinationToSearch.regiongroup = [
                              property[1]
                            ]
                            break
                          case 'cities[0][city_id]':
                          case 'cities[0][code]':
                            delete packageSearchObject.destinationToSearch
                              .regiongroup
                            delete packageSearchObject.destinationToSearch
                              .region
                            packageSearchObject.destinationToSearch.city = [
                              property[1]
                            ]
                            break
                          case 'regions[]':
                            delete packageSearchObject.destinationToSearch
                              .regiongroup
                            delete packageSearchObject.destinationToSearch.city
                            packageSearchObject.destinationToSearch.region = [
                              property[1]
                            ]
                        }
                      })
                      findLocationBasedPackageOffer = true
                    }
                  })
                  .then(function() {
                    if (findLocationBasedPackageOffer) {
                      // set data start and end (today+29 to today+88)
                      let startDate = new Date()
                      let endDate = new Date()
                      startDate.setDate(startDate.getDate() + 29)
                      endDate.setDate(endDate.getDate() + 88)
                      packageSearchObject.startDate = fecha.format(
                        startDate,
                        'YYYY-MM-DD'
                      )
                      packageSearchObject.endDate = fecha.format(
                        endDate,
                        'YYYY-MM-DD'
                      )
                      if (vm.$store.getters.getLocale === 'en-US') {
                        packageSearchObject.airport = [
                          'SEA',
                          'SFO',
                          'LAX',
                          'PHX',
                          'DEN',
                          'ATL',
                          'MIA',
                          'BOS',
                          'NYC',
                          'CHI'
                        ]
                      } else if (vm.$store.getters.getLocale === 'de-AT') {
                        packageSearchObject.airport = [
                          'GRZ',
                          'LNZ',
                          'INN',
                          'SZG',
                          'VIE',
                          'MUC'
                        ]
                      } else {
                        packageSearchObject.airport = [
                          'FRA',
                          'DUS',
                          'TXL',
                          'SXF',
                          'HAM',
                          'MUC'
                        ]
                      }
                      let pageType = 'undefined'
                      let pageId = 'undefined'
                      if (window.dataLayer.length > 0) {
                        // fill up data for proper attribution
                        if (window.dataLayer[0].hasOwnProperty('pageType')) {
                          pageType = window.dataLayer[0].pageType
                        }
                        if (window.dataLayer[0].hasOwnProperty('pagePath')) {
                          // for black pearl pages
                          pageId = window.dataLayer[0].pagePath
                        }
                        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
                          pageId = window.dataLayer[0].pagePostId
                        }
                      }
                      if (
                        window.gtm_tracking !== undefined &&
                        window.gtm_tracking !== null
                      ) {
                        if (window.gtm_tracking.hasOwnProperty('pageType')) {
                          pageType = window.gtm_tracking.pageType
                        }
                        if (window.gtm_tracking.hasOwnProperty('pagePath')) {
                          // for black pearl pages
                          pageId = window.gtm_tracking.pagePath
                        }
                        if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
                          pageId = window.gtm_tracking.pagePostId
                        }
                      }
                      packageSearchObject.product = pageType
                      packageSearchObject.pageid = pageId
                      packageSearchObject.country = vm.$store.getters.getCountry.toLowerCase()
                      packageData = packageSchema.setPackageSchema(
                        packageSearchObject
                      )
                      axios
                        .post(packageConfig.searchEndpoint, packageData, {
                          headers: ''
                        })
                        .then(function(response) {
                          // set only data to packageList when response has offers
                          if (response.data.config.count.total > 0) {
                            vm.packageList.push(response.data)
                          } else {
                            vm.packageList = null
                          }
                          vm.packageListFull = true
                          vm.notEmpty = true
                        })
                        .catch(() => {
                          vm.packageList = null
                          vm.packageListFull = true
                        })
                    } else {
                      vm.packageList = null
                      vm.packageListFull = true
                    }
                  })
              } else {
                vm.packageList = null
                vm.packageListFull = true
              }

              // Second Object are hotel config
              let hotelSearchObject = hotelSetup
              hotelSearchObject.country = vm.$store.getters.getCountry.toLowerCase()
              hotelSearchObject.language = vm.$store.getters.getLocaleShort.toLowerCase()
              if (vm.searchTag !== '') {
                let findLocationBasedHotelOffer = false
                // get automated destination from autosuggest with searching with url tag
                if (vm.$store.getters.getLocaleShort.toLowerCase() === 'de') {
                  vm.searchTerm = vm.formatGermanUmlaute(vm.searchTag)
                }
                axios
                  .get(
                    'https://cna.holidaypirates.group/v1/suggest?data[term]=' +
                      vm.searchTerm +
                      '&data[filters][types]=places,iata&config[target]=&config[type]=&config[source]=123&config[language]=' +
                      vm.$store.getters.getLocaleShort.toLowerCase()
                  )
                  .then(function(response) {
                    if (response.data.data.results.length > 0) {
                      // set date start (today+10 )
                      let startDate = new Date()
                      startDate.setDate(startDate.getDate() + 10)
                      hotelSearchObject.startDate = fecha.format(
                        startDate,
                        'YYYY-MM-DD'
                      )
                      delete hotelSearchObject.destinationToSearch
                      hotelSearchObject.destinationToSearch = {}
                      let resultDestination =
                        response.data.data.results[0].values.payload
                      let destinationArray = resultDestination.split('_')
                      hotelSearchObject.destinationToSearch[
                        destinationArray[0]
                      ] = [destinationArray[1]]
                      findLocationBasedHotelOffer = true
                    }
                  })
                  .then(function() {
                    if (findLocationBasedHotelOffer) {
                      hotelSearchObject.endDate = vm.getEndDate(
                        hotelSearchObject.startDate
                      )
                      let pageType = 'undefined'
                      let pageId = 'undefined'
                      if (window.dataLayer.length > 0) {
                        // fill up data for proper attribution
                        if (window.dataLayer[0].hasOwnProperty('pageType')) {
                          pageType = window.dataLayer[0].pageType
                        }
                        if (window.dataLayer[0].hasOwnProperty('pagePath')) {
                          // for black pearl pages
                          pageId = window.dataLayer[0].pagePath
                        }
                        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
                          pageId = window.dataLayer[0].pagePostId
                        }
                      }
                      if (
                        window.gtm_tracking !== undefined &&
                        window.gtm_tracking !== null
                      ) {
                        if (window.gtm_tracking.hasOwnProperty('pageType')) {
                          pageType = window.gtm_tracking.pageType
                        }
                        if (window.gtm_tracking.hasOwnProperty('pagePath')) {
                          // for black pearl pages
                          pageId = window.gtm_tracking.pagePath
                        }
                        if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
                          pageId = window.gtm_tracking.pagePostId
                        }
                      }
                      hotelSearchObject.product = pageType
                      hotelSearchObject.pageid = pageId
                      let hotelData = hotelSchema.setHotelSchema(
                        hotelSearchObject
                      )
                      axios
                        .post(
                          'https://cna.holidaypirates.group/v1/search',
                          hotelData,
                          {
                            headers: { 'Content-Type': 'application/json' }
                          }
                        )
                        .then(function(response) {
                          vm.hotelList.push(response.data)
                          vm.hotelListFull = true
                          vm.notEmpty = true
                        })
                        .catch(() => {
                          vm.hotelList = null
                          vm.hotelListFull = true
                        })
                    } else {
                      vm.hotelList = null
                      vm.hotelListFull = true
                    }
                  })
              }

              let flightSearchObject = flightSetup
              let startDate = new Date()
              let endDate = new Date()
              startDate.setDate(startDate.getDate() + 20)
              endDate.setDate(endDate.getDate() + 200)
              flightSearchObject.departureDepTime.start = fecha.format(
                startDate,
                'YYYY-MM-DD'
              )
              flightSearchObject.departureDepTime.end = fecha.format(
                endDate,
                'YYYY-MM-DD'
              )
              flightSearchObject.country = vm.$store.getters.getCountry.toLowerCase()
              flightSearchObject.language = vm.$store.getters.getLocaleShort.toLowerCase()
              // Third Object are flight config
              if (vm.searchTag !== '') {
                let findTagFlightOffer = false
                // get automated destination from autosuggest with searching with url tag
                axios
                  .get(
                    'https://autocomplete.holidaypirates.group/v1/suggest?data[term]=' +
                      vm.searchTag +
                      // '&data[filters][types]=&config[target]=dest&config[type]=kiwi&config[source]=123&config[language]=' + // use kiwi
                      '&data[filters][types]=&config[target]=airport&config[type]=kayak&config[source]=123&config[language]=' +
                      vm.$store.getters.getLocaleShort.toLowerCase()
                  )
                  .then(function(response) {
                    if (response.data.data.results.length > 0) {
                      // const resultPayload = response.data.data.results[0].values.payload // When use Kiwi
                      const resultPayload =
                        response.data.data.results[0].values.iata
                      // const arrivalAirportContent = resultPayload.split('_') // When use Kiwi
                      flightSearchObject.arrivalAirport = [
                        {
                          // type: arrivalAirportContent[0], // when use Kiwi
                          type: 'airport',
                          // value: arrivalAirportContent[1] // when use Kiwi
                          value: resultPayload
                        }
                      ]
                      findTagFlightOffer = true
                    }
                  })
                  .then(function() {
                    if (findTagFlightOffer) {
                      let flightData = null
                      flightSearchObject.departureAirport = [
                        {
                          type: 'country',
                          value: vm.$store.getters.getLocale.split('-')[1]
                        }
                      ]
                      for (
                        let i = flightSearchObject.departureAirport.length - 1;
                        i >= 0;
                        i--
                      ) {
                        if (
                          flightSearchObject.departureAirport[i] ===
                          flightSearchObject.arrivalAirport
                        ) {
                          flightSearchObject.departureAirport.splice(i, 1)
                        }
                      }
                      let pageType = 'undefined'
                      let pageId = 'undefined'
                      if (window.dataLayer.length > 0) {
                        // fill up data for proper attribution
                        if (window.dataLayer[0].hasOwnProperty('pageType')) {
                          pageType = window.dataLayer[0].pageType
                        }
                        if (window.dataLayer[0].hasOwnProperty('pagePath')) {
                          // for black pearl pages
                          pageId = window.dataLayer[0].pagePath
                        }
                        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
                          pageId = window.dataLayer[0].pagePostId
                        }
                      }
                      if (
                        window.gtm_tracking !== undefined &&
                        window.gtm_tracking !== null
                      ) {
                        if (window.gtm_tracking.hasOwnProperty('pageType')) {
                          pageType = window.gtm_tracking.pageType
                        }
                        if (window.gtm_tracking.hasOwnProperty('pagePath')) {
                          // for black pearl pages
                          pageId = window.gtm_tracking.pagePath
                        }
                        if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
                          pageId = window.gtm_tracking.pagePostId
                        }
                      }
                      flightSearchObject.product = pageType
                      flightSearchObject.pageid = pageId
                      if (flightSearchObject.type === 'oneway') {
                        flightData = flightSchema.setOneWayFlightSchema(
                          flightSearchObject
                        )
                      } else {
                        flightData = flightSchema.setReturnFlightSchema(
                          flightSearchObject
                        )
                      }
                      axios
                        .post(
                          'https://cn.holidaypirates.group/v1.1/search',
                          flightData,
                          {
                            headers: ''
                          }
                        )
                        .then(function(response) {
                          vm.flightList.push(response.data)
                          vm.flightListFull = true
                          vm.notEmpty = true
                        })
                        .catch(() => {
                          vm.flightList = null
                          vm.flightListFull = true
                        })
                    } else {
                      vm.flightList = null
                      vm.flightListFull = true
                    }
                  })
              }
            }
          } else {
            // remove anchor navigation on blog page
            if (
              document.getElementById('js-alternative_deals_anchor') !== null
            ) {
              document.getElementById(
                'js-alternative_deals_anchor'
              ).style.display = 'none'
            }
          }
        })
        .catch(() => {})
    }

    // Check for blog post pages if highlights are allowed
    let pageType = null
    if (window.dataLayer.length > 0) {
      if (window.dataLayer[0].hasOwnProperty('pageType')) {
        pageType = parseInt(window.dataLayer[0].pageType)
      }
    }
    if (pagePostId === null && pageType != null) {
      // on blackpearl pages
      let vm = this
      if (vm.searchTag !== '') {
        const packageConfig = vm.setPackageProvider()
        let packageSearchObject = packageSetup
        packageSearchObject.language = vm.$store.getters.getLocaleShort
        let packageData = null
        let findLocationBasedPackageOffer = false
        vm.searchTerm =
          vm.searchTag[0].toUpperCase() + vm.searchTag.substring(1)
        // First Object are package config
        if (vm.searchTag !== '' && vm.$store.getters.getLocaleShort === 'de') {
          // get automated destination from autosuggest with searching with url tag
          axios
            .get(
              packageConfig.autosuggestEndpoint +
                '?data[term]=' +
                vm.searchTag +
                '&data[filters][types]=' +
                packageConfig.data.filters.types +
                '&config[target]=' +
                packageConfig.config.target +
                '&config[type]=' +
                packageConfig.config.type +
                '&config[source]=123&config[language]=' +
                vm.$store.getters.getLocaleShort.toLowerCase()
            )
            .then(function(response) {
              if (response.data.data.results.length > 0) {
                let resultDestination =
                  response.data.data.results[0].values.payload
                let payLoadArray = resultDestination.split('&')
                payLoadArray.forEach(payload => {
                  let property = payload.split('=')
                  switch (property[0]) {
                    case 'region_groups[]':
                      delete packageSearchObject.destinationToSearch.city
                      delete packageSearchObject.destinationToSearch.region
                      packageSearchObject.destinationToSearch.regiongroup = [
                        property[1]
                      ]
                      break
                    case 'cities[0][city_id]':
                    case 'cities[0][code]':
                      delete packageSearchObject.destinationToSearch.regiongroup
                      delete packageSearchObject.destinationToSearch.region
                      packageSearchObject.destinationToSearch.city = [
                        property[1]
                      ]
                      break
                    case 'regions[]':
                      delete packageSearchObject.destinationToSearch.regiongroup
                      delete packageSearchObject.destinationToSearch.city
                      packageSearchObject.destinationToSearch.region = [
                        property[1]
                      ]
                  }
                })
                findLocationBasedPackageOffer = true
              }
            })
            .then(function() {
              if (findLocationBasedPackageOffer) {
                // set data start and end (today+29 to today+88)
                let startDate = new Date()
                let endDate = new Date()
                startDate.setDate(startDate.getDate() + 29)
                endDate.setDate(endDate.getDate() + 88)
                packageSearchObject.startDate = fecha.format(
                  startDate,
                  'YYYY-MM-DD'
                )
                packageSearchObject.endDate = fecha.format(
                  endDate,
                  'YYYY-MM-DD'
                )
                if (vm.$store.getters.getLocale === 'en-US') {
                  packageSearchObject.airport = [
                    'SEA',
                    'SFO',
                    'LAX',
                    'PHX',
                    'DEN',
                    'ATL',
                    'MIA',
                    'BOS',
                    'NYC',
                    'CHI'
                  ]
                } else if (vm.$store.getters.getLocale === 'de-AT') {
                  packageSearchObject.airport = [
                    'GRZ',
                    'LNZ',
                    'INN',
                    'SZG',
                    'VIE',
                    'MUC'
                  ]
                } else if (vm.$store.getters.getLocale === 'de-CH') {
                  packageSearchObject.airport = [
                    'ZRH',
                    'GVA',
                    'BSL',
                    'BRN',
                    'ACH',
                    'LUG',
                    'SIR'
                  ]
                } else {
                  packageSearchObject.airport = [
                    'FRA',
                    'DUS',
                    'TXL',
                    'SXF',
                    'HAM',
                    'MUC'
                  ]
                }
                let pageType = 'undefined'
                let pageId = 'undefined'
                if (window.dataLayer.length > 0) {
                  // fill up data for proper attribution
                  if (window.dataLayer[0].hasOwnProperty('pageType')) {
                    pageType = window.dataLayer[0].pageType
                  }
                  if (window.dataLayer[0].hasOwnProperty('pagePath')) {
                    // for black pearl pages
                    pageId = window.dataLayer[0].pagePath
                  }
                  if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
                    pageId = window.dataLayer[0].pagePostId
                  }
                }
                if (
                  window.gtm_tracking !== undefined &&
                  window.gtm_tracking !== null
                ) {
                  if (window.gtm_tracking.hasOwnProperty('pageType')) {
                    pageType = window.gtm_tracking.pageType
                  }
                  if (window.gtm_tracking.hasOwnProperty('pagePath')) {
                    // for black pearl pages
                    pageId = window.gtm_tracking.pagePath
                  }
                  if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
                    pageId = window.gtm_tracking.pagePostId
                  }
                }
                packageSearchObject.product = pageType
                packageSearchObject.pageid = pageId
                packageSearchObject.country = vm.$store.getters.getCountry.toLowerCase()
                packageData = packageSchema.setPackageSchema(
                  packageSearchObject
                )
                axios
                  .post(packageConfig.searchEndpoint, packageData, {
                    headers: ''
                  })
                  .then(function(response) {
                    // set only data to packageList when response has offers
                    if (response.data.config.count.total > 0) {
                      vm.packageList.push(response.data)
                    } else {
                      vm.packageList = null
                    }
                    vm.packageListFull = true
                    vm.notEmpty = true
                  })
                  .catch(() => {
                    vm.packageList = null
                    vm.packageListFull = true
                  })
              } else {
                vm.packageList = null
                vm.packageListFull = true
              }
            })
        } else {
          vm.packageList = null
          vm.packageListFull = true
        }

        // Second Object are hotel config
        let hotelSearchObject = hotelSetup
        hotelSearchObject.country = vm.$store.getters.getCountry.toLowerCase()
        hotelSearchObject.language = vm.$store.getters.getLocaleShort.toLowerCase()
        if (vm.searchTag !== '') {
          let findLocationBasedHotelOffer = false
          // get automated destination from autosuggest with searching with url tag
          if (vm.$store.getters.getLocaleShort.toLowerCase() === 'de') {
            vm.searchTerm = vm.formatGermanUmlaute(vm.searchTag)
          }
          axios
            .get(
              'https://cna.holidaypirates.group/v1/suggest?data[term]=' +
                vm.searchTerm +
                '&data[filters][types]=places,iata&config[target]=&config[type]=&config[source]=123&config[language]=' +
                vm.$store.getters.getLocaleShort.toLowerCase()
            )
            .then(function(response) {
              if (response.data.data.results.length > 0) {
                // set date start (today+10 )
                let startDate = new Date()
                startDate.setDate(startDate.getDate() + 10)
                hotelSearchObject.startDate = fecha.format(
                  startDate,
                  'YYYY-MM-DD'
                )
                delete hotelSearchObject.destinationToSearch
                hotelSearchObject.destinationToSearch = {}
                let resultDestination =
                  response.data.data.results[0].values.payload
                let destinationArray = resultDestination.split('_')
                hotelSearchObject.destinationToSearch[destinationArray[0]] = [
                  destinationArray[1]
                ]
                findLocationBasedHotelOffer = true
              }
            })
            .then(function() {
              if (findLocationBasedHotelOffer) {
                hotelSearchObject.endDate = vm.getEndDate(
                  hotelSearchObject.startDate
                )
                let pageType = 'undefined'
                let pageId = 'undefined'
                if (window.dataLayer.length > 0) {
                  // fill up data for proper attribution
                  if (window.dataLayer[0].hasOwnProperty('pageType')) {
                    pageType = window.dataLayer[0].pageType
                  }
                  if (window.dataLayer[0].hasOwnProperty('pagePath')) {
                    // for black pearl pages
                    pageId = window.dataLayer[0].pagePath
                  }
                  if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
                    pageId = window.dataLayer[0].pagePostId
                  }
                }
                if (
                  window.gtm_tracking !== undefined &&
                  window.gtm_tracking !== null
                ) {
                  if (window.gtm_tracking.hasOwnProperty('pageType')) {
                    pageType = window.gtm_tracking.pageType
                  }
                  if (window.gtm_tracking.hasOwnProperty('pagePath')) {
                    // for black pearl pages
                    pageId = window.gtm_tracking.pagePath
                  }
                  if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
                    pageId = window.gtm_tracking.pagePostId
                  }
                }
                hotelSearchObject.product = pageType
                hotelSearchObject.pageid = pageId
                let hotelData = hotelSchema.setHotelSchema(hotelSearchObject)
                axios
                  .post(
                    'https://cna.holidaypirates.group/v1/search',
                    hotelData,
                    {
                      headers: { 'Content-Type': 'application/json' }
                    }
                  )
                  .then(function(response) {
                    vm.hotelList.push(response.data)
                    vm.hotelListFull = true
                    vm.notEmpty = true
                  })
                  .catch(() => {
                    vm.hotelList = null
                    vm.hotelListFull = true
                  })
              } else {
                vm.hotelList = null
                vm.hotelListFull = true
              }
            })
        }

        let flightSearchObject = flightSetup
        let startDate = new Date()
        let endDate = new Date()
        startDate.setDate(startDate.getDate() + 20)
        endDate.setDate(endDate.getDate() + 200)
        flightSearchObject.departureDepTime.start = fecha.format(
          startDate,
          'YYYY-MM-DD'
        )
        flightSearchObject.departureDepTime.end = fecha.format(
          endDate,
          'YYYY-MM-DD'
        )
        flightSearchObject.country = vm.$store.getters.getCountry.toLowerCase()
        flightSearchObject.language = vm.$store.getters.getLocaleShort.toLowerCase()

        // Third Object are flight config
        if (vm.searchTag !== '') {
          let findTagFlightOffer = false
          // get automated destination from autosuggest with searching with url tag
          axios
            .get(
              'https://autocomplete.holidaypirates.group/v1/suggest?data[term]=' +
                vm.searchTag +
                // '&data[filters][types]=&config[target]=dest&config[type]=kiwi&config[source]=123&config[language]=' + // use kiwi
                '&data[filters][types]=&config[target]=airport&config[type]=kayak&config[source]=123&config[language]=' +
                vm.$store.getters.getLocaleShort.toLowerCase()
            )
            .then(function(response) {
              if (response.data.data.results.length > 0) {
                // const resultPayload = response.data.data.results[0].values.payload // When use Kiwi
                const resultPayload = response.data.data.results[0].values.iata
                // const arrivalAirportContent = resultPayload.split('_') // When use Kiwi
                flightSearchObject.arrivalAirport = [
                  {
                    // type: arrivalAirportContent[0], // when use Kiwi
                    type: 'airport',
                    // value: arrivalAirportContent[1] // when use Kiwi
                    value: resultPayload
                  }
                ]
                findTagFlightOffer = true
              }
            })
            .then(function() {
              if (findTagFlightOffer) {
                let flightData = null
                flightSearchObject.departureAirport = [
                  {
                    type: 'country',
                    value: vm.$store.getters.getLocale.split('-')[1]
                  }
                ]
                for (
                  let i = flightSearchObject.departureAirport.length - 1;
                  i >= 0;
                  i--
                ) {
                  if (
                    flightSearchObject.departureAirport[i] ===
                    flightSearchObject.arrivalAirport
                  ) {
                    flightSearchObject.departureAirport.splice(i, 1)
                  }
                }
                let pageType = 'undefined'
                let pageId = 'undefined'
                if (window.dataLayer.length > 0) {
                  // fill up data for proper attribution
                  if (window.dataLayer[0].hasOwnProperty('pageType')) {
                    pageType = window.dataLayer[0].pageType
                  }
                  if (window.dataLayer[0].hasOwnProperty('pagePath')) {
                    // for black pearl pages
                    pageId = window.dataLayer[0].pagePath
                  }
                  if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
                    pageId = window.dataLayer[0].pagePostId
                  }
                }
                if (
                  window.gtm_tracking !== undefined &&
                  window.gtm_tracking !== null
                ) {
                  if (window.gtm_tracking.hasOwnProperty('pageType')) {
                    pageType = window.gtm_tracking.pageType
                  }
                  if (window.gtm_tracking.hasOwnProperty('pagePath')) {
                    // for black pearl pages
                    pageId = window.gtm_tracking.pagePath
                  }
                  if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
                    pageId = window.gtm_tracking.pagePostId
                  }
                }
                flightSearchObject.product = pageType
                flightSearchObject.pageid = pageId
                if (flightSearchObject.type === 'oneway') {
                  flightData = flightSchema.setOneWayFlightSchema(
                    flightSearchObject
                  )
                } else {
                  flightData = flightSchema.setReturnFlightSchema(
                    flightSearchObject
                  )
                }
                axios
                  .post(
                    'https://cn.holidaypirates.group/v1.1/search',
                    flightData,
                    {
                      headers: ''
                    }
                  )
                  .then(function(response) {
                    vm.flightList.push(response.data)
                    vm.flightListFull = true
                    vm.notEmpty = true
                  })
                  .catch(() => {
                    vm.flightList = null
                    vm.flightListFull = true
                  })
              } else {
                vm.flightList = null
                vm.flightListFull = true
              }
            })
        }
      }
    }
  },
  methods: {
    getDateFormat() {
      if (this.$store.getters.getLocale === 'en-US') {
        return 'MM/DD/YYYY'
      }
      return 'DD.MM.YYYY'
    },
    getTimeFormat() {
      let timeFormat = 'HH:mm'
      return timeFormat
    },
    getEndDate(startDate) {
      let endDate = new Date(new Date(startDate).getTime())
      endDate = new Date(endDate.setDate(endDate.getDate() + 1))
      let day = endDate.getDate()
      let month = endDate.getMonth() + 1
      let year = endDate.getFullYear()
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }
      return year + '-' + month + '-' + day
    },
    trackPage() {
      if (this.trackHostNames.includes(window.location.hostname)) {
        let pageData = {
          url:
            window.location.protocol +
            '//' +
            window.location.host +
            '/' +
            window.location.pathname,
          config: window.bananasHighlightsConfigData,
          language: this.$store.getters.getLocale,
          position: this.getPositionOnPage()
        }
        dbPages.trackPage(pageData)
        dbViews.trackView(pageData, this)
      } else {
        this.trackingAllowed = false
        // Set store flag to false for tracking is allowed
        this.$store.dispatch('updateTrackingIsAllowed')
      }
    },
    getPositionOnPage() {
      let position = 0
      let documentHeight = document.documentElement.scrollHeight
      let unifiedSearchStart = document.getElementsByClassName(
        'c-highlights'
      )[0].offsetTop
      // document split in 3 parts
      let documentPartHeight = documentHeight / 3
      if (unifiedSearchStart < documentPartHeight) {
        position = 1
      } else if (unifiedSearchStart < documentPartHeight * 2) {
        position = 2
      } else {
        position = 3
      }
      return position
    },
    setUserId() {
      if (typeof localStorage !== 'undefined') {
        try {
          if (localStorage.getItem('hp-bn_userId') !== null) {
            // bn_userId exists in localStorage and set to Vuex for tracking
            this.$store.dispatch(
              'updateUniqueId',
              localStorage.getItem('hp-bn_userId')
            )
          } else if (localStorage.getItem('hp-us_userId') !== null) {
            // us_userId exists in localStorage and set to Vuex for tracking
            this.$store.dispatch(
              'updateUniqueId',
              localStorage.getItem('hp-us_userId')
            )
          } else {
            // Generate unique user id
            let uniqueId =
              uniqId('bn-') +
              '_' +
              Math.floor(Math.random() * Math.floor(100000000))
            localStorage.setItem('hp-bn_userId', uniqueId)
            this.$store.dispatch('updateUniqueId', uniqueId)
          }
        } catch (e) {}
      }
    },
    checkTrackingAllowed() {
      // Test Cookie with tracking rules
      // this.$cookies.set('tarteaucitron', '!snowplow=false!doubleclick=true!hotjar=true!googletagmanager=true!trustpilot=true!facebook=true!instagram=true!pinterest=true!twitter=true!youtube=true')
      if (this.$cookies.isKey('tarteaucitron')) {
        let trackingAllowed = this.$cookies.get('tarteaucitron')
        trackingAllowed = trackingAllowed.split('!')
        trackingAllowed = trackingAllowed[1].split('=')
        if (trackingAllowed[1] !== 'true') {
          this.trackingAllowed = false
          // Set store flag to false for tracking is allowed
          this.$store.dispatch('updateTrackingIsAllowed')
        } else {
          if (!this.trackHostNames.includes(window.location.hostname)) {
            this.trackingAllowed = false
            // Set store flag to false for tracking is allowed
            this.$store.dispatch('updateTrackingIsAllowed')
          }
        }
      }
      // Everytime true on localhost for development
      if (window.location.hostname === 'localhost') {
        this.trackingAllowed = true
      }
    },
    getCityName(localeName, lat, ln) {
      if (localeName === '') {
        axios
          .get(
            'https://iatacodes.org/api/v6/nearby?api_key=79e7bfc8-0549-4090-913b-b4fc7570d737&lat=' +
              lat +
              '&lng=' +
              ln +
              '&distance=5&lang=de'
          )
          .then(function(response) {
            axios
              .get(
                'https://iatacodes.org/api/v6/cities?api_key=79e7bfc8-0549-4090-913b-b4fc7570d737&code=' +
                  response.data.code +
                  '&lang=de'
              )
              .then(function(response) {
                return response.data.name
              })
          })
      } else {
        return localeName
      }
    },
    setPackageProvider() {
      let configProvider = {}
      configProvider.autosuggestEndpoint =
        'https://autocomplete.holidaypirates.group/v1/suggest'
      configProvider.searchEndpoint =
        'https://tm.holidaypirates.group/v1/search'
      configProvider.data = {
        filters: {
          types: 'places'
        }
      }
      configProvider.config = {
        type: 'ibe',
        target: 'dest'
      }
      /*
      if (this.$store.getters.getLocale === 'en-US') {
        configProvider.autosuggestEndpoint =
          'https://tremo-tmf.holidaypirates.group/v1.1/suggest'
        configProvider.searchEndpoint =
          'https://tremo-tmf.holidaypirates.group/v1.1/search'
        configProvider.data = {
          filters: {
            types: ''
          }
        }
        configProvider.config = {
          type: 'peakwork',
          target: 'dest'
        }
      } else {
        // default de-DE config
        configProvider.autosuggestEndpoint =
          'https://autocomplete.holidaypirates.group/v1/suggest'
        configProvider.searchEndpoint =
          'https://tm.holidaypirates.group/v1/search'
        configProvider.data = {
          filters: {
            types: 'places'
          }
        }
        configProvider.config = {
          type: 'ibe',
          target: 'dest'
        }
      }
      */
      return configProvider
    },
    formatGermanUmlaute(value) {
      value = value.toLowerCase()
      value = value.replace(/ae/g, 'ä')
      value = value.replace(/oe/g, 'ö')
      value = value.replace(/ue/g, 'ü')
      return value
    }
  }
}
</script>

<style lang="scss">
@import './scss/bananas.scss';
</style>
